'use strict';

var self = module.exports = {

    init: function() {

        /**
         * Inizializzo l'audio
         */
        $('[data-js="audio"]').removeClass('hide');
        self.play(global.media);
    },

    play: function(media) {
        media.play();
    },

    stop: function(media) {
        media.pause();
    },

    fadeIn: function (media) {

        if (!media.volume) {

            var volume = 0,
                setVolume = 1,
                speed = 0.1;

            media.volume = volume;

            self.play(media);

            var fadeInAudio = setInterval(function() {
                volume += speed;
                media.volume = volume.toFixed(1);

                if (volume.toFixed(1) >= setVolume) {
                    clearInterval(fadeInAudio);
                }

            }, 50);
        }
    },

    fadeOut: function (media) {

        if (media.volume) {

            var volume = 1,
                setVolume = 0,
                speed = 0.1;

            media.volume = volume;

            var fadeOutAudio = setInterval(function() {
                volume -= speed;
                media.volume = volume.toFixed(1);

                if (volume.toFixed(1) <= setVolume) {
                    clearInterval(fadeOutAudio);
                    self.stop(media);
                }

            }, 50);
        }
    }
};